import React, { FC } from 'react';

import gears from 'Shared/assets/images/gears.gif';
import clearcover_agent_hub_logo from 'Shared/assets/images/clearcover_agent_hub_logo.png';

import styles from './styles.module.css';
import { Brand } from '@clearcover/atlas';
import { getSalutation } from 'Shared/utils';
import classNames from 'classnames';
import { useAuth0 } from '../AuthProvider';

// This is a screen to be used when something has gone quite wrong
export const Maintenance: FC = () => {
  const { user, logout } = useAuth0();
  return (
    <div className={styles.container}>
      <header className={classNames(styles.header)}>
        <div className={styles.logo}>
          <Brand />
        </div>
        <div className={styles.training}>
          <a href="https://resources.clearcover.com/hc/en-us" target="blank">
            <img
              src={clearcover_agent_hub_logo}
              alt="Clearcover Agent Hub"
              className={styles.hubLogo}
            />
          </a>
        </div>
        <div className={styles.right}>
          <div className={styles.greeting}>
            {user && (
              <div
                className={classNames(styles.greetingText, 'fs-mask')}
                data-testid="header-greeting"
              >
                {`Good ${getSalutation()}, ${user.firstName}`}
              </div>
            )}
            <div
              className={styles.logout}
              onClick={logout}
              data-testid="header-logout"
            >
              Logout
            </div>
          </div>
          {user && (
            <div className={styles.bubble}>
              {user.firstName[0]}
              {user.lastName[0]}
            </div>
          )}
        </div>
      </header>
      <main
        role="main"
        className={styles.routeContainer}
        data-testid="maintenance-route"
      >
        <div className={styles.page}>
          <div className={styles.content}>
            <img src={gears} alt="Maintenance Gears" className={styles.image} />
            <h1>Our systems are currently under maintenance</h1>
            <p>
              We're currently performing essential maintenance to improve your
              experience. We'll be back up and running shortly. We apologize for
              any inconvenience caused and thank you for your understanding.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};
